import Modal from "components/HOCS/Modal";
import { PrivateLockBlue } from "graphics/icons/BranchBar/PrivateLock";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentActiveEffice } from "slices/sharedSelectors";
import { selectRoomLinkModal, setRoomLinkModal } from "slices/textSlice";
import RoomLinkMain from "./RoomLinkMain/RoomLinkMain";
import { isPrivateEffice } from "helpers/efficeHelpers";
import { selectSpaceBoxActive } from "slices/spaceMediaSlice";
import { selectSpaceNode } from "slices/spaceSlice";

const RoomLinkModal = () => {
  const dispatch = useDispatch();
  const roomLinkModal = useSelector(selectRoomLinkModal);
  const roomNode = useSelector((state) =>
    selectSpaceBoxActive(state)
      ? selectSpaceNode(state)
      : selectCurrentActiveEffice(state)
  );

  if (roomLinkModal) {
    return (
      <Modal
        growth={true}
        noBackDropClick={false}
        lightBackDrop={true}
        header={
          <div className="add-people-header add-people-constrict">
            Share a link for{" "}
            {isPrivateEffice(roomNode) && (
              <>
                nbsp;&nbsp;&nbsp;
                <span
                  style={{
                    position: "relative",
                    bottom: "2px",
                  }}
                >
                  <PrivateLockBlue />
                </span>
              </>
            )}
            &nbsp;
            <span className="d-inline-block dotdotdot font-extra-bold">
              {roomNode.content}
            </span>
          </div>
        }
        content={<RoomLinkMain node={roomNode} />}
        onDismiss={() => {
          dispatch(setRoomLinkModal(false));
        }}
      />
    );
  } else {
    return null;
  }
};

export default RoomLinkModal;
